<script lang="ts" setup>
  import renderRichText from '@/utils/renderSbRichText'

  interface IColumnHeadingAndDescription {
    heading?: string
    description: string
  }

  const props = defineProps<{
    blok: IColumnHeadingAndDescription
  }>()

  const content = computed(() => renderRichText(props.blok.description))
</script>

<template>
  <div class="text-center lg:!text-left">
    <h2
      v-if="blok.heading"
      class="text-white text-h1"
    >
      {{ blok.heading }}
    </h2>
    <div
      class="max-w-39 text-body-2 md:max-w-full lg:max-w-52 lg:!text-body-1"
      v-html="content"
    />
  </div>
</template>
